import React, { useRef } from "react";
import style from "./index.module.scss";
import { message, Modal, Popover } from "antd";
import SettingModal from "../../../SettingModal";
import useModalHandler from "utils/useModalHandler";
import { deleteVotePaper, exportVote, VoteItem, VoteState } from "service/vote";
import usePromiseCallback from "utils/usePromiseCallback";
import { errorMessage } from "../../../../../../service/service";

interface DropDownProps {
    weekTimeId: number;
    voteId: number;
    data: VoteItem;
    onShowVote: (voteId: number) => void;
    onChange: () => void;
}

export default function DropDown({
    weekTimeId,
    voteId,
    data,
    onShowVote,
    onChange
}: DropDownProps) {
    const ref = useRef<HTMLDivElement>(null);
    const modal = useModalHandler();

    const onDelete = usePromiseCallback(async function () {
        Modal.confirm({
            getContainer,
            title: `删除“${data.title}”？`,
            content:
                "投票活动删除后，该活动中的所有投票数据都将被删除且不可恢复，确定要删除吗？",
            onOk: async () => {
                try {
                    await deleteVotePaper(weekTimeId, voteId);
                    message.success("删除成功!");
                    onChange();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    });

    function onOk() {
        onChange();
        modal.close();
    }

    function getContainer(): any {
        return document.querySelector(".PopupContainer");
    }

    const popover = (
        <div className={style.popover}>
            {data.status !== VoteState.Done && (
                <button onClick={modal.open}>设置</button>
            )}
            {data.status === VoteState.Done && (
                <button onClick={() => exportVote(voteId)}>导出</button>
            )}
            <button onClick={onDelete}>删除</button>
        </div>
    );

    return (
        <div ref={ref} className={style.root}>
            <Popover
                content={popover}
                placement="bottom"
                overlayClassName={style.popoverWrapper}
                getPopupContainer={() => ref.current!}>
                <button className={style.more} />
            </Popover>

            <SettingModal
                id={voteId}
                visible={modal.visible}
                weekTimeId={weekTimeId}
                onCancel={modal.close}
                onOk={onOk}
                onShowVote={onShowVote}
            />
        </div>
    );
}
